export interface TleSubLocation {
  /** Globally unique, stable ID. Never use the display name as an identifier. */
  id: string;
  parentId: string;
  name: string;
  latitude: number;
  longitude: number;
  description?: string;
  /** Optional override for the existing satellite API's locationName lookup. */
  tleLocationName?: string;
}

export interface TleParentLocation {
  id: string;
  name: string;
  /** Lookup name accepted by the existing satellite API. */
  tleLocationName: string;
  subLocations: TleSubLocation[];
}

export interface TleLocationCatalogResponse {
  locations: TleParentLocation[];
}

export type TlePassStatus = 'idle' | 'queued' | 'loading' | 'ready' | 'empty' | 'error';

/** Colors belong to the UI, rather than the API or current checkbox order. */
export class LocationColorPalette {
  private readonly colors = new Map<string, string>();
  private readonly palette = [
    '#0066ff', '#079b38', '#8250df', '#f47b08', '#d92d45',
    '#008c95', '#c53694', '#a67c00', '#4652bf', '#007eae',
  ];

  getLocationColor(id: string): string {
    const existing = this.colors.get(id);
    if (existing) return existing;
    const index = this.colors.size;
    const color = this.palette[index] ?? `hsl(${((index - this.palette.length) * 137.508 + 17) % 360}, 68%, 40%)`;
    this.colors.set(id, color);
    return color;
  }
}

export function filterTleLocations(locations: TleParentLocation[], query: string): TleParentLocation[] {
  const term = query.trim().toLocaleLowerCase();
  if (!term) return locations;
  return locations.flatMap(parent => {
    if (parent.name.toLocaleLowerCase().includes(term)) return [parent];
    const subLocations = (parent.subLocations ?? []).filter(location =>
      `${location.name} ${location.description ?? ''}`.toLocaleLowerCase().includes(term)
    );
    return subLocations.length ? [{ ...parent, subLocations }] : [];
  });
}
